<div class="d-inline-flex align-items-center gap-2" *ngIf="orderDetail">
	<button
		*ngIf="orderDetail.stateEnum !== orderStatus.REJECTED"
		type="button"
		class="btn btn-sm d-inline-flex align-items-center gap-2 text-nowrap ci-approve-reject__btn--approve px-3"
		[disabled]="disabledApprove"
		(click)="approveOrder()"
	>
		<i class="fa-regular fa-thumbs-up"></i>
		<span>{{ approveBtn }}</span>
	</button>

	<button
		*ngIf="orderDetail.stateEnum !== orderStatus.APPROVED"
		type="button"
		class="btn btn-sm d-inline-flex align-items-center gap-2 text-nowrap ci-approve-reject__btn--reject px-3"
		[disabled]="disabledReject"
		(click)="toggleRejectionBox()"
	>
		<i *ngIf="!isRecallingBtn" class="fa-regular fa-thumbs-down"></i>
		<span *ngIf="isRecallingBtn" class="spinner-border spinner-border-sm"></span>
		<span>{{ rejectBtn }}</span>
	</button>
</div>

<div
	class="cv-rejection-box position-absolute top-100 end-0 border shadow bg-white p-3 overflow-auto"
	*ngIf="rejectionBoxOpen"
>
	<label class="form-label fw-bold">Client Notes:</label>
	<textarea class="form-control" [(ngModel)]="clientNote" placeholder="Add the client notes here..."></textarea>

	<label class="form-label fw-bold mt-2">Vendor Rejection Summary</label>
	<textarea class="form-control summary" [(ngModel)]="rejectionSummary"></textarea>

	<div class="d-flex align-items-center mt-3">
		<a
			href="javascript:void(0)"
			class="text-uppercase text-primary"
			ngxClipboard
			[cbContent]="rejectionSummary | stripHTMLTags"
		>
			Copy to Clipboard
		</a>
		<button
			type="button"
			class="btn btn-danger btn-sm ms-auto me-1"
			(click)="rejectOrder()"
			[disabled]="disabledReject"
		>
			Reject
		</button>
		<button type="button" class="btn btn-light btn-sm" (click)="toggleRejectionBox()">Cancel</button>
	</div>
</div>
